import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'; // import cx from 'classnames'

import $ from 'jquery';
import moment from 'moment';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import DateRange from '../ui/react-ui/date-range';
import Progress from '../ui/react-ui/progress.jsx';
import DropDown from '../ui/react-ui/dropdown';
import MapeTerminal from './mape-terminal';
import MapeGate from './mape-gate';
import MapeDelivery from './mape-delivery';
import MapeRoadSection from './mape-roadSection'; // api

import { getMapeIttVehicleVolumesByGateToGate, getMapeIttVehicleVolumesByWeek, getMapeZoneVisitByWeek, getMapeZoneVisitByTerminal, getMapeIttGateToGateList, getMapeIttByGateToGate, getMapeIttByWeek, getMapeTerminalLineByWeek, getMapeTerminalLineByTerminalDeliverType, getMapeRoadSectionList, getMapeRoadSectionByWeek, getMapeRoadSectionById } from '../../api/mapeAPI'; // redux

import { setTerminalsMapeData, setTerminalsMapeByWeek, setGateToAndFroList, setGateToAndFroMapeData, setGateToAndFroMapeTotal, setGateToAndFroMapeByWeek, setVehicleVolumes, setDeliveryMapeByTerminalDeliverType, setDeliveryMapeByWeek, setDateRange, setRoadSectionList, setRoadSectionByWeek, setRoadSectionMapeData, reset } from '../../redux/setting-mape';
var t = i18n.getFixedT(null, 'setting-mape');
var gt = i18n.getFixedT(null, 'app');
var Mape = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$mape = _useSelector.mape,
      dateRange = _useSelector$mape.dateRange,
      dateRangeChangeSwitch = _useSelector$mape.dateRangeChangeSwitch,
      terminalId = _useSelector$mape.terminalId,
      gateToAndFroId = _useSelector$mape.gateToAndFroId,
      deliveryId = _useSelector$mape.deliveryId,
      roadSectionId = _useSelector$mape.roadSectionId;

  var dispatch = useDispatch();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDateInput = _useState2[0],
      setShowDateInput = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      predictionType = _useState4[0],
      setPredictionType = _useState4[1];

  var isMounted = useRef(); // const isChange = useRef(true)
  // const beforeDateRange = useRef()

  var id = props.id;
  var initDateRange = {
    from: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD HH:mm'),
    to: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD HH:mm')
  };
  var dateDropDownList = [];
  var dateDropDownStart = moment('2022-07', 'YYYY-MM');
  var dateDropDownEnd = moment().subtract(1, 'months');

  while (dateDropDownStart.isSameOrBefore(dateDropDownEnd, 'month')) {
    dateDropDownList.push({
      value: dateDropDownEnd.startOf('month').format('YYYY-MM-DD HH:mm') + '_' + dateDropDownEnd.endOf('month').format('YYYY-MM-DD HH:mm'),
      text: dateDropDownEnd.format('YYYY-MM')
    });
    dateDropDownEnd.subtract(1, 'month');
  }

  var handleChangeDateTimeDropDown = function handleChangeDateTimeDropDown(dateRange) {
    dispatch(setDateRange({
      from: _.split(dateRange, '_')[0],
      to: _.split(dateRange, '_')[1]
    }));
  };

  var handleChangeDateTime = function handleChangeDateTime(dateRange) {
    dispatch(setDateRange(dateRange));
  }; // const handleCloseDateRange = value => {
  //     if(_.isEqual(beforeDateRange.current, value))
  //         return
  //     dispatch(setDateRangeChangeSwitch(!isChange.current))
  // }


  var fetchData = function fetchData() {
    var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (resolve, reject) {
      Progress.startSpin();
      var date = initDateRange;
      var oriGateIdByWeek = '',
          dstGateIdByWeek = '',
          deliveryAryId = '',
          deliveryType = '',
          roadSectionIdByWeek = '';

      if (!init) {
        date = dateRange;

        if (!_.isEmpty(gateToAndFroId)) {
          var gateIdAry = gateToAndFroId.split('-');
          oriGateIdByWeek = gateIdAry[0];
          dstGateIdByWeek = gateIdAry[1];
        }

        if (!_.isEmpty(deliveryId)) {
          var deliveryAry = deliveryId.split('-');
          var type = {
            'PICKUP': 'PickUp',
            'RETURN': 'Return'
          };
          deliveryAryId = deliveryAry[0];
          deliveryType = type[deliveryAry[1]];
        }

        if (!_.isEmpty(roadSectionId)) roadSectionIdByWeek = roadSectionId;
      }

      var getMapeZoneVisitByWeek_api = getMapeZoneVisitByWeek(contextRoot, true, date, predictionType, init ? '' : terminalId);
      var getMapeZoneVisitByTerminal_api = getMapeZoneVisitByTerminal(contextRoot, true, date, predictionType);
      var getMapeIttGateToGateList_api = getMapeIttGateToGateList(contextRoot, true);
      var getMapeIttByGateToGate_api = getMapeIttByGateToGate(contextRoot, true, date, predictionType, '', '');
      var getMapeIttByWeek_api = getMapeIttByWeek(contextRoot, true, date, predictionType, oriGateIdByWeek, dstGateIdByWeek);
      var getMapeIttVehicleVolumesByWeek_api = getMapeIttVehicleVolumesByWeek(contextRoot, true, date, predictionType, oriGateIdByWeek, dstGateIdByWeek);
      var getMapeIttVehicleVolumesByGateToGate_api = getMapeIttVehicleVolumesByGateToGate(contextRoot, true, date, predictionType, '', '');
      var getMapeTerminalLineByTerminalDeliverType_api = getMapeTerminalLineByTerminalDeliverType(contextRoot, true, date, predictionType, '', '');
      var getMapeTerminalLineByWeek_api = getMapeTerminalLineByWeek(contextRoot, true, date, predictionType, deliveryAryId, deliveryType);
      var getMapeRoadSectionList_api = getMapeRoadSectionList(contextRoot, true);
      var getMapeRoadSectionByWeek_api = getMapeRoadSectionByWeek(contextRoot, true, date, predictionType, roadSectionIdByWeek);
      var getMapeRoadSectionById_api = getMapeRoadSectionById(contextRoot, true, date, predictionType);
      $.when(getMapeZoneVisitByWeek_api, getMapeZoneVisitByTerminal_api, getMapeIttGateToGateList_api, getMapeIttByGateToGate_api, getMapeIttByWeek_api, getMapeTerminalLineByTerminalDeliverType_api, getMapeTerminalLineByWeek_api, getMapeIttVehicleVolumesByWeek_api, getMapeIttVehicleVolumesByGateToGate_api, getMapeRoadSectionList_api, getMapeRoadSectionByWeek_api, getMapeRoadSectionById_api).then(function (result_getMapeZoneVisitByWeek, result_getMapeZoneVisitByTerminal, result_getMapeIttGateToGateList, result_getMapeIttByGateToGate, result_getMapeIttByWeek, result_getMapeTerminalLineByTerminalDeliverType, result_getMapeTerminalLineByWeek, result_getMapeIttVehicleVolumesByWeek, result_getMapeIttVehicleVolumesByGateToGate, result_getMapeRoadSectionList, result_getMapeRoadSectionByWeek, result_getMapeRoadSectionById) {
        // Terminals Mape By Week
        var mapeZoneByWeek = _.cloneDeep(result_getMapeZoneVisitByWeek.content).sort(function (a, b) {
          return a.day - b.day;
        });

        mapeZoneByWeek.unshift(mapeZoneByWeek.pop());
        dispatch(setTerminalsMapeByWeek(mapeZoneByWeek)); // Terminals Mape

        dispatch(setTerminalsMapeData(result_getMapeZoneVisitByTerminal.content)); // Gate To Gate List

        var gateToGateList = _.map(result_getMapeIttGateToGateList.content, function (el) {
          return {
            value: el.oriGateId + '-' + el.dstGateId,
            text: el.oriGateName + '至' + el.dstGateName
          };
        });

        dispatch(setGateToAndFroList(gateToGateList)); // Gate To Gate Mape

        dispatch(setGateToAndFroMapeData(result_getMapeIttByGateToGate.content));
        dispatch(setGateToAndFroMapeTotal(result_getMapeIttByGateToGate.value)); // Vehicle Volumes Gate To Gate

        dispatch(setVehicleVolumes(result_getMapeIttVehicleVolumesByGateToGate.content)); // Gate To Gate Mape By Week

        var vehicleVolumes = result_getMapeIttVehicleVolumesByWeek.content;

        var mapeGateByWeek = _.cloneDeep(result_getMapeIttByWeek.content).sort(function (a, b) {
          return a.day - b.day;
        });

        mapeGateByWeek.unshift(mapeGateByWeek.pop());
        mapeGateByWeek = _.map(mapeGateByWeek, function (el) {
          var vehicleItem = _.find(vehicleVolumes, function (o) {
            return o.day === el.day;
          });

          _.map(el.data, function (i) {
            var v = _.find(vehicleItem.data, function (j) {
              return j.time === i.time;
            });

            i.avgVehicleVolumes = v.avgVehicleVolumes;
          });

          return el;
        });
        dispatch(setGateToAndFroMapeByWeek(mapeGateByWeek)); // Terminal Line Deliver Type

        dispatch(setDeliveryMapeByTerminalDeliverType(result_getMapeTerminalLineByTerminalDeliverType.content)); // Terminal Deliver Mape By week

        var deliveryByWeek = _.cloneDeep(result_getMapeTerminalLineByWeek.content).sort(function (a, b) {
          return a.day - b.day;
        });

        deliveryByWeek.unshift(deliveryByWeek.pop());
        dispatch(setDeliveryMapeByWeek(deliveryByWeek)); // road section

        var roadSectionList = _.map(result_getMapeRoadSectionList.content, function (el) {
          return {
            value: el.id,
            text: el.name
          };
        });

        dispatch(setRoadSectionList(roadSectionList));

        var mapeRoadSectionByWeek = _.cloneDeep(result_getMapeRoadSectionByWeek.content).sort(function (a, b) {
          return a.day - b.day;
        });

        mapeRoadSectionByWeek.unshift(mapeRoadSectionByWeek.pop());
        dispatch(setRoadSectionByWeek(mapeRoadSectionByWeek));
        dispatch(setRoadSectionMapeData(result_getMapeRoadSectionById.content));
        resolve('successed');
      }).catch(function (error) {
        return reject(error);
      });
    });
  };

  var handleExportCSV = function handleExportCSV() {
    $.ajax({
      url: "".concat(contextRoot, "/mape/export"),
      method: 'GET',
      beforeSend: function beforeSend(xhr) {
        Progress.startSpin();
      },
      data: {
        predSeq: predictionType,
        start: "".concat(dateRange.from, ":00"),
        end: "".concat(dateRange.to, ":59")
      },
      xhrFields: {
        responseType: 'blob'
      },
      success: function success(data) {
        console.log(data);
        var a = document.createElement('a');
        a.style.display = 'none';
        a.href = window.URL.createObjectURL(data);
        a.setAttribute('download', "mape_".concat(_.replace(dateRange.from, ' ', '_'), ":00-").concat(_.replace(dateRange.to, ' ', '_'), ":59.xlsx"));
        a.click();
        document.body.appendChild(a);
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
        Progress.done();
      }
    });
  };

  var keycodeListener = function keycodeListener(e) {
    if (e.altKey && e.ctrlKey && e.key == 'g') setShowDateInput(true);
    if (e.altKey && e.ctrlKey && e.key == 'h') setShowDateInput(false);
  }; // useEffect(() => {
  //     if(!isMounted.current)
  //         return null
  //     isChange.current = dateRangeChangeSwitch
  //     beforeDateRange.current = dateRange
  //     fetchData().then(result => {
  //         Progress.done()
  //         isMounted.current = true
  //     }).catch(error => {
  //         Progress.done()
  //         console.log(error)
  //     })
  // }, [dateRangeChangeSwitch])


  useEffect(function () {
    if (!isMounted.current) {
      // beforeDateRange.current = initDateRange
      dispatch(setDateRange(initDateRange));
      fetchData(true).then(function (result) {
        Progress.done();
        isMounted.current = true;
      }).catch(function (error) {
        Progress.done();
        console.log(error);
      });
    }

    var flatpickerTime = document.getElementsByClassName('flatpickr-time time24hr');

    _.forEach(flatpickerTime, function (el) {
      return el.style.display = 'none';
    });

    document.addEventListener('keydown', keycodeListener);
    return function () {
      document.removeEventListener("keydown", keycodeListener);
      dispatch(reset());
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "head-dateRange"
  }, !showDateInput && /*#__PURE__*/React.createElement("div", {
    className: "head-item"
  }, /*#__PURE__*/React.createElement("label", {
    className: "dropdown-label"
  }, t('lbl-month')), /*#__PURE__*/React.createElement(DropDown, {
    className: "date-dropdown-list",
    required: true,
    list: dateDropDownList,
    value: dateRange.from + '_' + dateRange.to,
    onChange: handleChangeDateTimeDropDown
  })), showDateInput && /*#__PURE__*/React.createElement(DateRange, {
    id: "datetime",
    enableTime: true,
    enableStartEndLabel: true,
    startLabel: t('lbl-start-time'),
    endLabel: t('lbl-end-time'),
    allowKeyIn: false,
    onChange: handleChangeDateTime // onClose={handleCloseDateRange}
    ,
    defaultValue: initDateRange,
    value: dateRange,
    limitRange: '30d' // t={(code, params) => {
    //     if (code === 'missing')
    //         return `Please input date`
    //     else {
    //         return `Invalid date format. Should be ${params.pattern}`
    //     }
    // }}

  }), /*#__PURE__*/React.createElement("div", {
    className: "head-item"
  }, /*#__PURE__*/React.createElement("label", {
    className: "dropdown-label"
  }, t('lbl-prediction-type')), /*#__PURE__*/React.createElement(DropDown, {
    className: "prediction-dropdown-list",
    required: true,
    list: [{
      value: '0',
      text: t('lbl-prediction-type-0')
    }, {
      value: '1',
      text: t('lbl-prediction-type-1')
    }, {
      value: '2',
      text: t('lbl-prediction-type-2')
    }],
    value: predictionType,
    onChange: setPredictionType
  })), /*#__PURE__*/React.createElement("button", {
    className: "button",
    onClick: function onClick() {
      return fetchData().then(function (result) {
        return Progress.done();
      });
    }
  }, gt('global.lbl-search')), /*#__PURE__*/React.createElement("button", {
    className: "button",
    onClick: handleExportCSV
  }, gt('global.lbl-export'))), /*#__PURE__*/React.createElement(MapeTerminal, {
    predictionType: predictionType
  }), /*#__PURE__*/React.createElement(MapeGate, {
    predictionType: predictionType
  }), /*#__PURE__*/React.createElement(MapeDelivery, {
    predictionType: predictionType
  }), /*#__PURE__*/React.createElement(MapeRoadSection, {
    predictionType: predictionType
  }));
});
Mape.defaultProps = {
  id: 'g-mape'
};
Mape.PropTypes = {
  id: PropTypes.string
};
export default Mape;